import * as React from 'react';
import Box from '@mui/material/Box';
import Modal from '@mui/material/Modal';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import { LimospayTextIcon } from '../../Svg';
import ModalTable from '../../components/ModalTable';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import BackIcon from '../../Svg/BackIcon';
import NewBackIcon from '../../Svg/NewBackIcon';


const style = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: "auto",
  bgcolor: 'background.paper',
  borderTop: '6px solid #00008B',
  boxShadow: 0,
  p: 4,
  height: "auto"
};


export default function ViewModal({open, onClose, row}) {

  return (
    

      <Modal
        keepMounted
        open={open}
        onClose={onClose}
        aria-labelledby="keep-mounted-modal-title"
        aria-describedby="keep-mounted-modal-description"
      >
        <Box sx={style} style={{
                      display: "flex",
                      alignItems: "center",
                      flexDirection: "column",
                    }}>
                         <LimospayTextIcon />
                         
          <Typography id="keep-mounted-modal-title" variant="h5" component="h2" marginTop={"10px"} >
                          View Insights
          </Typography>
          <Box display={"flex"}  justifyContent="flex-start"
          //  marginTop={"40px"}
           >
          {/* <Typography  id="keep-mounted-modal-description"  sx={{ mt: 2 }}>
           This Account was created at: {props.created_at}
          </Typography> */}
           <Box>
    <TableContainer sx={{ minWidth: "80%" }} >
      <Table  size="small" aria-label="a dense table" >
        <TableHead>
          <TableRow >
            <TableCell colSpan={2} sx={{fontWeight:"bold"}} align="center">Details</TableCell>
          </TableRow>
        </TableHead>
      <TableBody>
        <TableRow>

        <TableCell><b>Transaction Date</b></TableCell>
          <TableCell>{row?.created_at}</TableCell> 
        </TableRow>
       
        <TableRow>
          <TableCell><b>Reference Number</b></TableCell>
          <TableCell>{row?.slug}</TableCell>
         
        </TableRow>
        <TableRow>
        <TableCell><b>Amount</b></TableCell>
          <TableCell>{row?.amount}</TableCell>
        </TableRow>
        <TableRow>
        <TableCell><b>Account Name</b></TableCell>
          <TableCell>{row?.account_name || "N/A"}</TableCell>
        </TableRow>
        <TableRow>
        <TableCell><b>Sender</b></TableCell>
          <TableCell>{row?.sender_name || "N/A"}</TableCell>
        </TableRow>
        <TableRow>
        <TableCell><b>Status</b></TableCell>
          <TableCell>{row?.status}</TableCell>
        </TableRow>
        <TableRow>
        <TableCell><b>Transaction Type</b></TableCell>
          <TableCell>{row?.main_type}</TableCell>
        </TableRow>
        <TableRow>
        <TableCell><b>Wallet ID</b></TableCell>
          <TableCell>{row?.wallet_id}</TableCell>
        </TableRow>
        </TableBody>
       
      </Table>
    </TableContainer>
    <Box sx={{display:"flex", justifyContent:"center", marginTop:"15px"}}>
      <Button variant="contained" size='large' onClick={onClose} startIcon={<BackIcon/>} >Back</Button>
      
      </Box>
    </Box>
          
          </Box>
        
        </Box>
      </Modal>
   
  );
}
